import { render, staticRenderFns } from "./TreeForm.vue?vue&type=template&id=fae3803c&"
import script from "./TreeForm.vue?vue&type=script&lang=js&"
export * from "./TreeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports